import { Logger } from './index';
import { HELIX_WEB_SOCKET } from '../constants';
import { throttle } from 'lodash';

let channel;

const updateFunction = updateFunction => event => updateFunction(event);

const onMessage = (onUpdateFunction) => event => {
    const msg = JSON.parse(event.data);

    if (msg.type === 'response') {
        return;
    }

    const events = msg.data;
    if (msg.event === 'batch') {
        events.forEach((realEvents) => onUpdateFunction(realEvents));
    } else {
        onUpdateFunction(events);
    }
};

const onError = (e) => console.log('e', e);

const changeChannelTo = (command, channel) => {
    if (command !== 'subscribe' && command !== 'unsubscribe') {
        throw new Error('Unknown Command');
    }

    return JSON.stringify({
        command: command,
        data: {
            room: `twitchstats:${channel}:stats`
        }
    });
};

let ws;

const connect = () => {
    if (!ws) {
        return new Promise((resolve, reject) => {
            const _ws = new WebSocket(HELIX_WEB_SOCKET);
            // const _ws = new WebSocket('wss://twitchstats-ws.streamelements.com/')
            _ws.onopen = () => {
                ws = _ws;
                resolve(_ws);
            };
            _ws.onerror = (e) => reject(e);
            _ws.onerror = onError;
        });
    } else {
        return Promise.resolve()
    }
};

const whatToDoOnUpdate = (updateFn) => {
    if (typeof updateFn !== 'function') {
        throw new Error('updateFn is not, well, a fn?');
    }

    const updater = updateFunction(updateFn);
    ws.onmessage = onMessage(updater);
};

const unsubscribeFromChannel = (channel) => {
    ws.send(changeChannelTo('unsubscribe', channel));
};

const updateChannel = (newChannel) => {
    if (!ws) {
        return Promise.reject({message: 'No WS available'});
    }

    channel && ws.send(changeChannelTo('unsubscribe', channel));
    ws.send(changeChannelTo('subscribe', newChannel));

    channel = newChannel;
    return Promise.resolve();
};

const socket = {
    connect: connect,
    updateChannel,
    whatToDoOnUpdate,
    unsubscribeFromChannel,
};

export default socket;



// WEBPACK FOOTER //
// ./src/services/Socket.js